export const extractList = (response) => {
  if (!response) return [];
  return response?.data?.data?.data || response?.data?.data ||  [];
};
